import { IApiPerformanceStats, IPerformanceStats } from './IPerformanceStats'

class Transformer {
    static transform(data: IApiPerformanceStats): IPerformanceStats {
        return {
            personUuid: data.person_uuid,
            loyalty: {
                chosenMinutes: data.loyalty.chosen_minutes,
                randomCount: data.loyalty.random_count,
                chosenCount: data.loyalty.chosen_count,
                randomMinutes: data.loyalty.random_minutes,
            },
        }
    }
}

export default Transformer
